import { useSyncExternalStore } from 'react'
import {
  getServerThemeSnapshot,
  getThemeSnapshot,
  subscribeToTheme,
} from './theme-store'

export function useTheme() {
  return useSyncExternalStore(
    subscribeToTheme,
    getThemeSnapshot,
    getServerThemeSnapshot,
  )
}
